<div class="template">
    <p>##Name##</p> 
    <p>  ##Mobile##</p>
    <p>    ##CustomerNo##</p>
    <p>  ##ProductNo##</p>
    <p>    ##Amount##</p>
    <p>##Currency##</p>
  </div>